"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectionSelectInput = void 0;
const react_1 = __importDefault(require("react"));
const store_1 = require("../../../../store");
const __1 = require("../../../..");
const RedirectionSelectInput = ({ onSubmit, items, }) => {
    const chatbot = (0, store_1.useStoreState)((state) => state.chatbot.value);
    return (react_1.default.createElement("div", { className: "flex flex-row items-start w-full text-base" },
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement("div", { className: "flex flex-row flex-wrap" }, items.map((item, index) => {
                return (react_1.default.createElement("a", { key: index, onClick: () => onSubmit(item.value), target: "_blank", href: (0, __1.parseVariables)(item.url, chatbot.variables), className: "px-6 py-2 rounded-md hover: transition-colors duration-100 focus:outline-none mr-2 mb-2 typebot-button", rel: "noreferrer" }, item.value));
            })))));
};
exports.RedirectionSelectInput = RedirectionSelectInput;
//# sourceMappingURL=RedirectionSelectInput.js.map